import { SortingRule } from "react-table";

export const camelToSnakeCase = (input: string) => input.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const parseSortRule = <T>(sortRule: SortingRule<T>[]): Array<string> => {
  if (sortRule[0] != undefined) {
    const sortingRule = sortRule[0];
    const sortingRuleId = camelToSnakeCase(sortingRule.id);
    const parsedSortingRule = `${sortingRule.desc ? "-" : ""}${sortingRuleId}`;
    return [parsedSortingRule];
  }

  return [];
};

export const areAllRowsSelected = (animalIds: Array<string>, selectedAnimalIds: Set<string> | undefined) => {
  if (!selectedAnimalIds) {
    return false;
  }
  return animalIds.every((id) => selectedAnimalIds.has(id));
};

export const getPageFrom = ({
  totalNumberOfAnimals,
  pageIndex,
  pageSize,
}: {
  totalNumberOfAnimals: number;
  pageIndex: number;
  pageSize: number;
}) => {
  if (totalNumberOfAnimals === 0) {
    return 0;
  }

  if (pageIndex + 1 === 1) {
    return 1;
  }

  return pageIndex * pageSize + 1;
};

export const getPageTo = ({
  pageSize,
  pageFrom,
  totalNumberOfAnimals,
}: {
  pageSize: number;
  pageFrom: number;
  totalNumberOfAnimals: number;
}) => {
  const pageTo = pageFrom - 1 + pageSize;

  if (pageTo > totalNumberOfAnimals) {
    return totalNumberOfAnimals;
  }

  return pageTo;
};
